<template>
  <v-container >
    <entity-properties-row :label="$t('device.singular')">
      <span v-if="defectReport.writeInDeviceName">{{ defectReport.writeInDeviceName }}</span>
      <span v-if="defectReport.device">{{ defectReport.device | device }}</span>
    </entity-properties-row>

    <entity-properties-row :label="$t('defectReport.priority')"
                           :property="defectReport.priority | priority"/>

    <entity-properties-row :label="$t('defectReport.created')"
                           :property="defectReport.created | dateTime"/>

    <entity-properties-row :label="$t('defectReport.title')"
                           :property="defectReport.title"/>

    <entity-properties-row :label="$t('defectReport.description')">
      <preformatted-text-view :value="defectReport.description"/>
    </entity-properties-row>


    <entity-properties-row :label="$t('defectReport.status')">
      <span>{{defectReport.status | defectReportStatus}}</span>
    </entity-properties-row>

    <entity-properties-row :label="$t('defectReport.reportingUser')">
      <span v-if="defectReport.signer">{{defectReport.signer}}</span>
      <span v-if="!defectReport.signer">{{defectReport.reportingUser | user}}</span>
    </entity-properties-row>

    <entity-properties-row :label="$t('defectReport.documents')">
      <document-list :documents="documents"/>
    </entity-properties-row>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import DocumentList from '@/components/layouts/DocumentList';
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';

export default {
  name: 'DefectReportPropertiesView',
  components: { PreformattedTextView, EntityPropertiesRow, DocumentList },
  props:{
    defectReport: {
      required:true,
      type: Object,
    },
    documents: {
      required:true,
      type: Array,
    },
  },
};
</script>

<style scoped>

</style>
